export default "__VITE_ASSET__f3070f47__"